var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-menu',{attrs:{"offset-y":"","content-class":"category_menu"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","tile":""}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-menu")])],1)]}}])},[_c('Navbar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }